import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import BuildCapabilitiesSection from "./components/BuildCapabilitiesSection";
import BuildEvidenceSection from "./components/BuildEvidenceSection";
import BuildFinalCtaSection from "./components/BuildFinalCtaSection";
import BuildFooter from "./components/BuildFooter";
import BuildHeroSection from "./components/BuildHeroSection";
import BuildMethodSection from "./components/BuildMethodSection";
import BuildPromiseStrip from "./components/BuildPromiseStrip";
import BuildSystemSection from "./components/BuildSystemSection";
import BuildThesisSection from "./components/BuildThesisSection";
import BuildTopbar from "./components/BuildTopbar";
import "./build.css";

const Build = () => {
  const pageRef = useRef(null);

  // Fade blocks in as they scroll into view. The class is added straight to
  // the DOM; React leaves it alone because the className props never change.
  useEffect(() => {
    const items = pageRef.current.querySelectorAll(".apl-reveal");

    if (!("IntersectionObserver" in window)) {
      items.forEach((item) => item.classList.add("apl-in"));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("apl-in");
            observer.unobserve(entry.target);
          }
        }),
      { threshold: 0.12 }
    );
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="apl" ref={pageRef}>
      <Helmet>
        <title>
          Utiva AI Product Lab | From Business Problem to Working AI Product
        </title>
        <meta
          name="description"
          content="Bring Utiva one real business problem. The AI Product Lab assembles the right team to turn it into a working AI product your organisation can test."
        />
        <meta
          property="og:title"
          content="Utiva AI Product Lab | From Business Problem to Working AI Product"
        />
        <meta
          property="og:description"
          content="Bring Utiva one real business problem. The AI Product Lab assembles the right team to turn it into a working AI product your organisation can test."
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <a className="apl-skip" href="#main">
        Skip to content
      </a>
      <BuildTopbar />

      <main id="main">
        <BuildHeroSection />
        <BuildPromiseStrip />
        <BuildThesisSection />
        <BuildSystemSection />
        <BuildMethodSection />
        <BuildCapabilitiesSection />
        <BuildEvidenceSection />
        <BuildFinalCtaSection />
      </main>

      <BuildFooter />
    </div>
  );
};

export default Build;
